import React, { createContext, useContext, useState } from "react";
import { ToastContainer } from "react-toastify";

import AhoyMessageIndex from "./AhoyMessageIndex";

const AhoyMessageIndexContext = createContext();

export function useAhoyMessageIndexContext() {
  return useContext(AhoyMessageIndexContext);
}

const AhoyMessageIndexProvider = (props) => {
  const {
    csrfToken,
    user,
    team,
    teamMembership,
    enforceMarketingVenueAccessControl,
    emailDataSource,
    smsDataSource,
    trackablesUrl,
    subjectsUrl,
  } = props;

  const [activeTab, setActiveTab] = useState("email");
  const [dataTableRefreshedAt, setDataTableRefreshedAt] = useState(new Date());

  const refreshDataTable = () => {
    setDataTableRefreshedAt(new Date());
  };

  const value = {
    csrfToken,
    user,
    team,
    teamMembership,
    enforceMarketingVenueAccessControl,
    emailDataSource,
    smsDataSource,
    trackablesUrl,
    subjectsUrl,
    activeTab,
    setActiveTab,
    dataTableRefreshedAt,
    refreshDataTable,
  };

  return (
    <AhoyMessageIndexContext.Provider value={value}>
      {props.children}
    </AhoyMessageIndexContext.Provider>
  );
};

const AhoyMessageIndexContainer = (props) => (
  <AhoyMessageIndexProvider {...props}>
    <ToastContainer icon={false} />
    <AhoyMessageIndex />
  </AhoyMessageIndexProvider>
);

export default AhoyMessageIndexContainer;
